require("./bootstrap");

import Swal from "sweetalert2";
window.Swal = Swal;

import "../../vendor/rappasoft/laravel-livewire-tables/resources/imports/laravel-livewire-tables-all.js";
